module.exports = __webpack_public_path__ + "img/encryption.c3efe64d.svg";